<template>
  <div v-if="formData">
    <div class="row mt-5 b-form__row_type_flex">
      <div class="col-6">
        <div class="b-form__container">
          <label>
            {{$t('CONTENT.counterparty.legalForm')}}
            <span class="b-form__required">*</span>
          </label>
          <cool-select :list="allDirectoryLegalForms"
                       option-value="code"
                       option-text="fullName"
                       :placeholder="$t('CONTENT.choose')"
                       v-model="directoryLegalFormCode"></cool-select>
        </div>
      </div>
      <div class="col-6">
        <label for="fullName">
          {{$t('CONTENT.counterparty.fullCompanyName')}}
          <span class="b-form__required">*</span>
        </label>
        <input
          type="text"
          id="fullName"
          class="b-input"
          name="fullName"
          v-model="formData.fullName"
        />
      </div>
    </div>
    <div class="row mt-5 b-from__row_type_flex">
      <div class="col-6">
        <label for="shortName">
          {{$t('CONTENT.counterparty.shortCompanyName')}}
          <span class="b-form__required">*</span>
        </label>
        <input
          type="text"
          id="shortName"
          class="b-input"
          name="shortName"
          v-model="formData.shortName"
        />
      </div>
      <div class="col-6">
        <label for="latinName">{{$t('CONTENT.counterparty.latinCompanyName')}}</label>
        <input
          data-cy="choose-latin-name"
          type="text"
          id="latinName"
          class="b-input"
          name="latinName"
          v-model="formData.latinName"
        />
      </div>
    </div>
    <div class="row mt-5 b-from__row_type_flex">
      <div class="col-3">
        <label for="itn">
          {{$t('CONTENT.counterparty.itn')}}
<!--          <span class="b-form__required">*</span>-->
        </label>
        <input
          type="text"
          id="itn"
          class="b-input"
          name="ITN"
          v-model="formData.itn"
        />
      </div>
      <div class="col-3">
        <label for="rrc">
          {{$t('CONTENT.counterparty.rrc')}}
<!--          <span class="b-form__required">*</span>-->
        </label>
        <input
          type="text"
          id="rrc"
          class="b-input"
          name="RRC"
          v-model="formData.rrc"
        />
      </div>
      <div class="col-3">
        <label for="ogrn">{{$t('CONTENT.counterparty.ogrn')}}</label>
        <input
          data-cy="choose-ogrn"
          type="text"
          id="ogrn"
          class="b-input"
          name="OGRN"
          v-model="formData.ogrn"
        />
      </div>
    </div>
    <CounterpartyAddressForm :addresses="formData.addresses" />
    <div class="row mt-5 b-form__row_type_flex">
      <div class="col-6">
        <label for="externalId">{{$t('CONTENT.external_id')}}:</label>
        <input
          data-cy="choose-externalId"
          type="text"
          id="externalId"
          class="b-input"
          name="externalId"
          v-model="formData.externalId"
        />
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-8">
        <div class="b-form__container">
          <label for="comment">{{$t('CONTENT.comment')}}:</label>
          <textarea
            data-cy="choose-comment"
            class="b-textarea"
            id="comment"
            name="comment"
            v-model="formData.comment"
          ></textarea>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import CounterpartyAddressForm from "./CounterpartyAddressForm";

export default {
  components: {
    CounterpartyAddressForm
  },
  props: {
    formData: {
      required: true,
      type: Object
    }
  },
  computed: {
    ...mapGetters(["allDirectoryLegalForms"]),
    ...mapGetters(["allCounterpartyAddressTypes"]),
    directoryLegalFormCode: {
      get() {
        if(this.formData.directoryLegalFormCode !== null) {
          return this.formData.directoryLegalFormCode;
        } else {
          return null;
        }
      },
      set(newVal) {
        this.formData.directoryLegalFormCode = newVal;
      }
    }
  },
};
</script>
